import * as messagingKeys from 'constants/messagingKeys'
import { setConfiguration } from 'services/Configuration/actions'
import { setLanguage, toggleAppState, setUserId, setSessionData } from 'components/App/actions'
import { createList, createItem, updateList } from 'components/Items/actions'
import { fetchSaveShoppingList } from 'components/FormItems/actions/data'
import { INITIALIZE_APP } from 'components/App/constants/actionTypes'
import { SET_CONFIGURATION } from 'services/Configuration/constants/actionTypes'
import { CLOSE_WIDGET } from 'components/AppHeader/constants/actionTypes'
import { isSessionValid } from 'helpers/createSession'
import logger from 'helpers/logger'
import { setWrapperOrigin, setWrapperDeviceType, setWrapperRecipeSchemaItems, setWrapperCurrentUrl } from 'services/Wrapper/actions'


export default ({ getState, dispatch }) => next => (action) => {
    const result = next(action)
    const nextState = getState()

    switch (action.type) {
        case INITIALIZE_APP:
            window.top.postMessage({
                type: messagingKeys.INITIALIZE
            }, '*')

            window.addEventListener('message', wrapperMessagingHandler.bind(this, getState, dispatch))
            break

        case SET_CONFIGURATION:
            window.top.postMessage({
                type: messagingKeys.WIDGET_CONFIGURED,
                configuration: nextState.configuration
            }, nextState.wrapper.origin)
            break

        case CLOSE_WIDGET:
            window.top.postMessage({
                type: messagingKeys.CLOSE_WIDGET,
                isItemsChanged: nextState.items.isChanged
            }, nextState.wrapper.origin)

            dispatch(toggleAppState(false))
            break

        default:
            break
    }

    return result
}

let isSessionStarted = false
const wrapperMessagingHandler = (getState, dispatch, e) => {
    // TODO update
    if (!e.data.OOMWrapper) {
        return
    }

    const nextState = getState()

    if (e.data.type === 'init') {
        dispatch(setLanguage(e.data.language))
        dispatch(setWrapperOrigin(e.origin))
        dispatch(setConfiguration(e.data.partnerId))
        dispatch(setWrapperDeviceType(e.data.deviceType))
        dispatch(setWrapperCurrentUrl(e.data.url))

        if (e.data.schemaData) {
            dispatch(setWrapperRecipeSchemaItems(e.data.schemaData))
        }

        return
    }

    if (!isSessionStarted && e.data.isAction) {
        startSessionHandler(nextState, dispatch)
        isSessionStarted = true
    }

    switch(e.data.type) {
        case 'setItems': {
            e.data.items.forEach(item => dispatch(createItem(item)))
            break
        }

        case 'saveList': {
            dispatch(fetchSaveShoppingList())
            break
        }

        case 'setLanguage': {
            dispatch(setLanguage(e.data.language))
            break
        }

        case 'setUrl': {
            dispatch(setWrapperCurrentUrl(e.data.url))
            break
        }

        case 'widgetVisibilityChange': {
            if (e.data.isVisible) {
                dispatch(updateList())
            }

            break
        }

        case 'widgetClose': {
            window.top.postMessage({
                type: messagingKeys.CLOSE_WIDGET,
                isItemsChanged: nextState.items.isChanged
            }, nextState.wrapper.origin)

            dispatch(toggleAppState(false))

            break
        }

        case 'widgetOpen': {
            dispatch(toggleAppState(true))
            break
        }

        case 'resize': {
            dispatch(setWrapperDeviceType(e.data.deviceType))
            break
        }

        default:
            logger('Unhandled message from wrapepr', 'info')
    }
}

const startSessionHandler = (nextState, dispatch) => {
    const userId = nextState.app.userId
    const prevSessionTimestamp = nextState.app.session.timeStamp

    const isUserCreated = !!userId
    const isSessionCreated = !!prevSessionTimestamp && isSessionValid(prevSessionTimestamp)


    // setting the missing data for first time users
    if (!isUserCreated) {
        dispatch(setUserId())
    }

    // update session
    dispatch(setSessionData())

    if (!nextState.items.listId) {
        dispatch(createList())
    }
}
